import React from 'react';
import { Avatar, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ColorViewerDto } from '../../modelView';
import { BlockOutlined, Clear, ColorLensRounded } from '@mui/icons-material';
import { UserDto } from '../../api';

const colorTypeMapper = (colorType: string) => {
  return colorType === 'WHITE' ? '#faefef' : colorType;
};

export default function UserAvatar(props: { user: UserDto | null }) {
  function stringToColor(string: string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }

  function stringAvatar(name: string) {
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
    };
  }

  if (!props.user) {
    return <Avatar sx={{ width: 75, height: 75 }} />;
  }

  return (
    <Avatar
      {...stringAvatar(props.user.fullName)}
      sx={{ width: 75, height: 75 }}
    />
  );
}
